import { useState } from 'react';
import {
  depositReceiptDownloadName,
  depositReceiptIsImage,
  depositReceiptIsPdf,
  resolveDepositReceiptHref,
} from '@/calendar/pwaBookingDetail';

type Props = {
  rawUrl: string;
};

export function DepositReceiptBlock({ rawUrl }: Props) {
  const [viewerOpen, setViewerOpen] = useState(false);
  const raw = rawUrl.trim();
  const href = resolveDepositReceiptHref(raw);
  const isData = raw.startsWith('data:');
  const isImg = depositReceiptIsImage(raw);
  const isPdf = depositReceiptIsPdf(raw);
  const showEmbedPreview = isImg || !isData || isPdf;
  const imageSrc = isData ? raw : href;
  const embedSrc = isData ? raw : href;

  return (
    <>
      {isImg ?
        <button
          type="button"
          className="cal-receipt-thumb-btn"
          aria-label="Ver comprobante en grande"
          onClick={() => setViewerOpen(true)}
        >
          <img src={imageSrc} alt="Comprobante de seña" className="cal-detail-receipt-img" />
        </button>
      : showEmbedPreview ?
        <button type="button" className="pwa-btn pwa-btn--secondary cal-receipt-link-btn" onClick={() => setViewerOpen(true)}>
          Ver comprobante
        </button>
      : <a href={raw} download={depositReceiptDownloadName(raw)} className="pwa-btn pwa-btn--secondary cal-receipt-link-btn">
          Descargar comprobante
        </a>}

      {viewerOpen ?
        <div
          className="cal-sheet-backdrop cal-receipt-viewer-backdrop"
          role="presentation"
          onClick={() => setViewerOpen(false)}
        >
          <div
            className="cal-receipt-viewer"
            role="dialog"
            aria-modal="true"
            aria-label="Comprobante de seña"
            onClick={(e) => e.stopPropagation()}
          >
            <header className="cal-receipt-viewer__head">
              <h3 className="cal-receipt-viewer__title">Comprobante de seña</h3>
              <button
                type="button"
                className="cal-sheet__close"
                aria-label="Cerrar"
                onClick={() => setViewerOpen(false)}
              >
                ×
              </button>
            </header>
            <div className="cal-receipt-viewer__body">
              {isImg ?
                <img src={imageSrc} alt="" className="cal-receipt-viewer__img" />
              : <iframe title="Comprobante" src={embedSrc} className="cal-receipt-viewer__iframe" />}
            </div>
            <footer className="cal-receipt-viewer__foot">
              {isData ?
                <a href={raw} download={depositReceiptDownloadName(raw)} className="pwa-btn pwa-btn--secondary">
                  Descargar
                </a>
              : null}
              <button type="button" className="pwa-btn pwa-btn--primary" onClick={() => setViewerOpen(false)}>
                Cerrar
              </button>
            </footer>
          </div>
        </div>
      : null}
    </>
  );
}
